<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom pb-5">
        <div class="row">
            <div class="col-lg-12">
                <div class="header">
                    <h4 class="title">Expense Detail {{schoolname}} </h4>
                </div>
                <div class="row justify-content-center card">
                    <div class="col-lg-12 col-md-12 col-12 p-4">
                        <form #expenseDetail="ngForm" (ngSubmit)="onSubmit(data)" class="pb-3">
                            <h5 class="mt-2"><b>Maintanance expenses</b></h5>
                            <hr style="margin: 0;color: black;">
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                    <label><b>Expense type</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #ExpenseTypeID="ngModel" ngModel
                                        name="ExpenseTypeID" [(ngModel)]="data.ExpenseTypeID" required>
                                        <option *ngFor="let inf of expenses" [value]="inf.value"
                                            [selected]="data.ExpenseTypeID == inf.value">
                                            {{ inf.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="expenseDetail.submitted">
                                        <p *ngIf="data.ExpenseTypeID == 0 || data.ExpenseTypeID == undefined"
                                            class="error_message" style="color: red">
                                            Expense type is required 
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                    <label><b>Expense amount </b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #ExpenseAmount="ngModel" ngModel
                                        name="ExpenseAmount" [(ngModel)]="data.ExpenseAmount" maxlength="20"
                                        (keypress)="onlyDouble($event,data.ExpenseAmount)"
                                        placeholder="Enter maintanance amount" required>
                                    <span *ngIf="expenseDetail.submitted && ExpenseAmount.invalid">
                                        <p *ngIf="ExpenseAmount.errors.required" class="error_message"
                                            style="color: red;">
                                            Expense amount is required
                                        </p>
                                    </span>
                                    <span *ngIf="expenseDetail.submitted">
                                        <p *ngIf="data.ExpenseAmount == 0 && ExpenseAmount.valid"
                                            class="error_message" style="color: red;">
                                            Expense amount must be greater then zero
                                        </p>
                                    </span>
                                </div>
                                <!-- <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                    <label><b>Lumsum</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #LumsumMaintanance="ngModel" ngModel
                                        name="LumsumMaintanance" [(ngModel)]="data.LumsumMaintanance" maxlength="20"
                                        (keypress)="onlyDouble($event,data.LumsumMaintanance)"
                                        placeholder="Enter Lumsum maintanance amount" required>
                                    <span *ngIf="expenseDetail.submitted && LumsumMaintanance.invalid">
                                        <p *ngIf="LumsumMaintanance.errors.required" class="error_message"
                                            style="color: red;">
                                            Lumsum maintanance amount is required
                                        </p>
                                    </span>
                                    <span *ngIf="expenseDetail.submitted">
                                        <p *ngIf="data.LumsumMaintanance == 0 && LumsumMaintanance.valid" class="error_message"
                                            style="color: red;">
                                            Lumsum maintanance amount must be greater then zero
                                        </p>
                                    </span>
                                </div> -->
                            </div>
                            <h5 class="mt-4"><b>Tax expenses</b></h5>
                            <hr style="margin: 0;;color: black;">
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                    <label><b>Paid by trust</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #TaxByTrust="ngModel" ngModel
                                        name="TaxByTrust" [(ngModel)]="data.TaxByTrust" maxlength="20"
                                        (keypress)="onlyDouble($event,data.TaxByTrust)"
                                        placeholder="Enter tax amount paid by trust" required>
                                    <span *ngIf="expenseDetail.submitted && TaxByTrust.invalid">
                                        <p *ngIf="TaxByTrust.errors.required" class="error_message"
                                            style="color: red;">
                                            Tax amount is required
                                        </p>
                                    </span>
                                    <span *ngIf="expenseDetail.submitted">
                                        <p *ngIf="data.TaxByTrust == 0 && TaxByTrust.valid" class="error_message"
                                            style="color: red;">
                                            Tax amount must be greater then zero
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                    <label><b>Paid by college</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #TaxByCollege="ngModel" ngModel
                                        name="TaxByCollege" [(ngModel)]="data.TaxByCollege" maxlength="20"
                                        (keypress)="onlyDouble($event,data.TaxByCollege)"
                                        placeholder="Enter tax amount paid by college" required>
                                    <span *ngIf="expenseDetail.submitted && TaxByCollege.invalid">
                                        <p *ngIf="TaxByCollege.errors.required" class="error_message"
                                            style="color: red;">
                                            Tax amount is required
                                        </p>
                                    </span>
                                    <span *ngIf="expenseDetail.submitted">
                                        <p *ngIf="data.TaxByCollege == 0 && TaxByCollege.valid" class="error_message"
                                            style="color: red;">
                                            Tax amount must be greater then zero
                                        </p>
                                    </span>
                                </div>
                            </div>
                            <h5 class="mt-4"><b>Insurance</b></h5>
                            <hr style="margin: 0;;color: black;">
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                    <label><b>Student</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #StudentInsurance="ngModel" ngModel
                                        name="StudentInsurance" [(ngModel)]="data.StudentInsurance" maxlength="20"
                                        (keypress)="onlyDouble($event,data.StudentInsurance)"
                                        placeholder="Enter student insurance amount" required>
                                    <span *ngIf="expenseDetail.submitted && StudentInsurance.invalid">
                                        <p *ngIf="StudentInsurance.errors.required" class="error_message"
                                            style="color: red;">
                                            Student insurance amount is required
                                        </p>
                                    </span>
                                    <span *ngIf="expenseDetail.submitted">
                                        <p *ngIf="data.StudentInsurance == 0 && StudentInsurance.valid" class="error_message"
                                            style="color: red;">
                                            Student insurance amount must be greater then zero
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                    <label><b>Teaching</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #TeachingInsurance="ngModel" ngModel
                                        name="TeachingInsurance" [(ngModel)]="data.TeachingInsurance" maxlength="20"
                                        (keypress)="onlyDouble($event,data.TeachingInsurance)"
                                        placeholder="Enter teaching insurance amount" required>
                                    <span *ngIf="expenseDetail.submitted && TeachingInsurance.invalid">
                                        <p *ngIf="TeachingInsurance.errors.required" class="error_message"
                                            style="color: red;">
                                            Teaching insurance amount is required
                                        </p>
                                    </span>
                                    <span *ngIf="expenseDetail.submitted">
                                        <p *ngIf="data.TeachingInsurance == 0 && TeachingInsurance.valid" class="error_message"
                                            style="color: red;">
                                            Teaching insurance amount must be greater then zero
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                    <label><b> Non-Teaching</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #NonTeachingInsurance="ngModel" ngModel
                                        name="NonTeachingInsurance" [(ngModel)]="data.NonTeachingInsurance" maxlength="20"
                                        (keypress)="onlyDouble($event,data.NonTeachingInsurance)"
                                        placeholder="Enter non-teaching insurance amount" required>
                                    <span *ngIf="expenseDetail.submitted && NonTeachingInsurance.invalid">
                                        <p *ngIf="NonTeachingInsurance.errors.required" class="error_message"
                                            style="color: red;">
                                            Non-teaching insurance amount is required
                                        </p>
                                    </span>
                                    <span *ngIf="expenseDetail.submitted">
                                        <p *ngIf="data.NonTeachingInsurance == 0 && NonTeachingInsurance.valid" class="error_message"
                                            style="color: red;">
                                            Non-teaching insurance amount must be greater then zero
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                    <label><b> Building</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #BuildingInsurance="ngModel" ngModel
                                        name="BuildingInsurance" [(ngModel)]="data.BuildingInsurance" maxlength="20"
                                        (keypress)="onlyDouble($event,data.BuildingInsurance)"
                                        placeholder="Enter building insurance amount" required>
                                    <span *ngIf="expenseDetail.submitted && BuildingInsurance.invalid">
                                        <p *ngIf="BuildingInsurance.errors.required" class="error_message"
                                            style="color: red;">
                                            Building insurance amount is required
                                        </p>
                                    </span>
                                    <span *ngIf="expenseDetail.submitted">
                                        <p *ngIf="data.BuildingInsurance == 0 && BuildingInsurance.valid" class="error_message"
                                            style="color: red;">
                                            Building insurance amount must be greater then zero
                                        </p>
                                    </span>
                                </div>
                            </div>
                            <div class="mb-3 mt-2">
                                <button class="btn btn-success" type="submit" style="margin: 5px;">{{btnsubmittext}}</button>
                                <button class="btn btn-primary" type="button" (click)="resetForm()"
                                    style="margin: 5px;">Clear</button>
                                <button type="button" class="btn btn-danger" (click)="Cancel()">Cancel</button>
                            </div>
                        </form>
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-4">
                                <label><b>Year</b></label>
                                <select class="form-control" #YearID="ngModel" ngModel name="YearID"
                                     [(ngModel)]="yearid" (change)="getExpenseDetailList()" required>
                                    <option *ngFor="let year of yearlist" [value]="year.value"
                                        [selected]="yearid == year.value">
                                        {{ year.text }}
                                    </option>
                                </select>            
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-12">
                                <div class="table-responsive subject">
                                    <div>
                                        <div class="card col-mb-6 mt-2">
                                            <div class="card-header py-3">
                                                <input type="text" class="form-control bg-white border-0 small"
                                                    placeholder="Search for..." [(ngModel)]="searchtext"
                                                    aria-label="Search" aria-describedby="basic-addon2"
                                                    (keyup)="setpage()" />
                                            </div>
                                        </div>
                                        <table id="example" class="table table-striped table-bordered"
                                            style="width:100%">
                                            <thead>
                                                <tr>
                                                    <th class="pointer" scope="col" (click)="sortBy('SrNo')">Sr. No.</th>
                                                    <!-- <th class="pointer" scope="col" (click)="sortBy('ExpenseDate')">Expense Date</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('Amount')">Amount</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('Description')">Description </th> -->
                                                    <th class="pointer" scope="col" (click)="sortBy('ExpenseType')">Expense Type</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('ExpenseAmount')">Expense Amount</th>
                                                    <!-- <th class="pointer" scope="col" (click)="sortBy('LumsumMaintanance')">Lumsum Maintanance</th> -->
                                                    <th class="pointer" scope="col" (click)="sortBy('TaxByTrust')">Tax By Trust</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('TaxByCollege')">Tax By College</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('StudentInsurance')">Student Insurance</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('TeachingInsurance')">Teaching Insurance</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('NonTeachingInsurance')">NonTeaching Insurance</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('BuildingInsurance')">Building Insurance</th>
                                                    <th class="pointer" scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngIf="ExpenseDetaillist != undefined && ExpenseDetaillist.length != 0">
                                                <tr
                                                    *ngFor="let r of ExpenseDetaillist | filter:searchtext | paginate: { itemsPerPage: pageLimit, currentPage: p };let i = index">
                                                    <td>{{r.SrNo}}</td>
                                                    <td><p>{{r.ExpenseType}}</p></td>
                                                    <td><p>{{r.ExpenseAmount}}</p></td>
                                                    <!-- <td><p>{{r.LumsumMaintanance}}</p></td> -->
                                                    <td><p>{{r.TaxByTrust}}</p></td>
                                                    <td><p>{{r.TaxByCollege}}</p></td>
                                                    <td><p>{{r.StudentInsurance}}</p></td>
                                                    <td><p>{{r.TeachingInsurance}}</p></td>
                                                    <td><p>{{r.NonTeachingInsurance}}</p></td>
                                                    <td><p>{{r.BuildingInsurance}}</p></td>
                                                    <td>
                                                        <button type="button" class="btn btn-success rmb_10" (click)="editExpenseDetail(r.HashCode)">Edit</button>
                                                        &nbsp; <button type="button" class="btn btn-danger" (click)="deleteExpenseDetail(r.HashCode)">Delete</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody *ngIf="ExpenseDetaillist == undefined || ExpenseDetaillist.length == 0">
                                                <tr>
                                                    <td colspan="10" style="text-align: center;"> No Record Found </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="card-footer pb-0 pt-3" align="right">
                                            <pagination-controls (pageChange)="p = $event"></pagination-controls>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-login custom-footer">
        <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
        <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
    </div>
    <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white;">Please Wait.</p>
    </ngx-spinner>
</div>